import React from "react";
import Image from "../assets/images/thep.png";

const TherapistCard = ({ onClick, setSelectedDoctorId, item, selectedDoctorId }) => {
    return (
        <div
            className={
                selectedDoctorId === item?.doctor_id
                    ? "CardWrapper selectedCard"
                    : "CardWrapper"
            }
            onClick={onClick}
        >
            <div className="TherapistImg">
                <img
                    src={item?.profileImage || Image}
                    alt="Therapist"
                    style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "20%",
                        objectFit: "cover",
                        padding: "5px",

                        // border: "2px solid #ddd",
                    }}
                />
            </div>
            <div className="TherapistDetail">
                <h1>{item?.doctor_name}</h1>
                <p>Available</p>
            </div>
        </div>
    );
};

export default TherapistCard;
